<template>
  <div>
    <h3 class="blue-text">{{L10n('from-stock')}}</h3>
    <grid
      ref="grid"
      :config="gridConfig"
      class="no-grid-border"
      @handleCustomButtonGrid="handleCustom"
      @onGet="handlerGetData"
    />
    <dialog-confirm
      :isVisible="isVisibleConfirm"
      :statusID="statusID"
      @onCancel="handleCancel"
      @onConfirm="handleConfirm"
    />
  </div>
</template>

<script>
import GridConfig from './GridConfig'
import { waitValue } from '@/utils/promises'
import { ModelRFQ3Stock } from '../../models'

export default {
  name: 'StocksGridIndex',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'dialog-confirm': () => import(/* webpackChunkName: 'Parts' */ '@/Pages/Stock_Parts/StocksPart/DialogConfirm')
  },
  props: {
    isStatusAvailable: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    partID: { type: Number, required: true }
  },
  watch: {
    partID: {
      immediate: true,
      async handler () {
        const grid = await this.getGrid()
        if (!this.partID) {
          grid.resetData()
        } else {
          const stockID = this.checkQuery()
          let filters = [`partID==${this.partID}`, stockID && `id == ${stockID}`].filter((v) => v)
          grid.setFilters(filters.join(' && '))
          grid.loadData()
        }
      }
    }
  },
  data () {
    return {
      isVisibleConfirm: false,
      statusID: null,
      stockID: null,
      selectedRow: null
    }
  },
  computed: {
    gridConfig () {
      return GridConfig({ fnClassButton: this.classButton, disabledAdd: this.disabled, isStatusAvailable: this.isStatusAvailable })
    }
  },
  methods: {
    isConfirm (row) {
      return row.statusID !== 1
    },
    classButton (row) {
      return {
        'btn-red btn-red__important': this.isConfirm(row)
      }
    },
    async getGrid () {
      return waitValue(() => this.$refs['grid'])
    },
    handlerAddTo ({ row }) {
      let otherFields = {
        price: row.sellPrice,
        currencyID: row.sellExchCurrencyID,
        supplyDate: row.locationTitle
      }
      let data = this.copyObjectProps(ModelRFQ3Stock(), { ...row, ...otherFields })
      this.$emit('onAddQuote', data)
    },
    handleCustom ({ row }) {
      this.statusID = row.statusID
      this.selectedRow = row

      if (this.statusID === 6) {
        this.isVisibleConfirm = true
      } else {
        this.handleConfirm()
      }
    },
    handleCancel () {
      this.statusID = null
      this.selectedRow = null
      this.isVisibleConfirm = false
    },
    handleConfirm () {
      this.statusID = null
      this.isVisibleConfirm = false
      const row = { ...this.selectedRow }
      this.selectedRow = null
      this.handlerAddTo({ row })
    },
    checkQuery () {
      let query = { ...this.$route.query }
      const key = 'quick-rfq-part-stock-id'
      const id = query[key] || null
      delete query[key]
      this.$router.replace({ ...this.$router.currentRoute, query })
      this.stockID = id
      return id
    },
    handlerGetData (data) {
      if (this.stockID) {
        const rowData = data.find(({ id }) => id === this.stockID)
        this.handlerAddTo({ row: rowData })
      }
      this.stockID = null
    }
  }
}
</script>
